import {ReactComponent as IcnArrowDownSvg} from "./icn-arrow-down.svg";
import {ReactComponent as IcnArrowLeftSvg} from "./icn-arrow-left.svg";
import {ReactComponent as IcnArrowRightSvg} from "./icn-arrow-right.svg";
import {ReactComponent as IcnArrowRightUpSvg} from "./icn-arrow-right-up.svg";
import {ReactComponent as IcnBankFilledSvg} from "./icn-bank-filled.svg";
import {ReactComponent as IcnCalendarSvg} from "./icn-calendar.svg";
import {ReactComponent as IcnCalendarPlusSvg} from "./icn-calendar-plus.svg";
import {ReactComponent as IcnCheckDoneSvg} from "./icn-check-done.svg";
import {ReactComponent as IcnCheckVerifiedSvg} from "./icn-check-verified.svg";
import {ReactComponent as IcnChevronDownSvg} from './icn-chevron-down.svg';
import {ReactComponent as IcnChevronRightSvg} from './icn-chevron-right.svg';
import {ReactComponent as IcnChevronSelectorSvg} from './icn-chevron-selector.svg';
import {ReactComponent as IcnCircleDollarSvg} from './icn-circle-currency-dollar.svg';
import {ReactComponent as IcnCircleHelpSvg} from "./icn-circle-help.svg";
import {ReactComponent as IcnCirclePlusSvg} from './icn-circle-plus.svg';
import {ReactComponent as IcnCloseSvg} from './icn-close.svg';
import {ReactComponent as IcnCopySvg} from "./icn-copy.svg";
import {ReactComponent as IcnEyeSvg} from "./icn-eye.svg";
import {ReactComponent as IcnEyeOffSvg} from "./icn-eye-off.svg";
import {ReactComponent as IcnFingerprintSvg} from "./icn-fingerprint.svg";
import {ReactComponent as IcnFlipBackwardsSvg} from './icn-flip-backwards.svg';
import {ReactComponent as IcnInfoSvg} from "./icn-info.svg";
import {ReactComponent as IcnInfoFilledSvg} from './icn-info-filled.svg';
import {ReactComponent as IcnInfoOctogoneSvg} from "./icn-info-octogone.svg";
import {ReactComponent as IcnLogoutSvg} from "./icn-logout.svg";
import {ReactComponent as IcnQrCodeSvg} from "./icn-qr-code.svg";
import {ReactComponent as IcnSwitchHorizontalSvg} from './icn-switch-horizontal.svg';
import {ReactComponent as IcnTriangleSvg} from "./icn-triangle-warning.svg";

export const IcnArrowDown = IcnArrowDownSvg;
export const IcnArrowLeft = IcnArrowLeftSvg;
export const IcnArrowRight = IcnArrowRightSvg;
export const IcnArrowRightUp = IcnArrowRightUpSvg;
export const IcnBankFilled = IcnBankFilledSvg;
export const IcnCalendar = IcnCalendarSvg;
export const IcnCalendarPlus = IcnCalendarPlusSvg;
export const IcnCheckDone = IcnCheckDoneSvg;
export const IcnCheckVerified = IcnCheckVerifiedSvg;
export const IcnChevronDown = IcnChevronDownSvg;
export const IcnChevronRight = IcnChevronRightSvg;
export const IcnChevronSelector = IcnChevronSelectorSvg;
export const IcnCircleDollar = IcnCircleDollarSvg;
export const IcnCircleHelp = IcnCircleHelpSvg;
export const IcnCirclePlus = IcnCirclePlusSvg;
export const IcnClose = IcnCloseSvg;
export const IcnCopy = IcnCopySvg;
export const IcnEye = IcnEyeSvg;
export const IcnEyeOff = IcnEyeOffSvg;
export const IcnFingerprint = IcnFingerprintSvg;
export const IcnFlipBackwards = IcnFlipBackwardsSvg;
export const IcnInfo = IcnInfoSvg;
export const IcnInfoFilled = IcnInfoFilledSvg;
export const IcnInfoOctogone = IcnInfoOctogoneSvg;
export const IcnLogout = IcnLogoutSvg;
export const IcnQrCode = IcnQrCodeSvg;
export const IcnSwitchHorizontal = IcnSwitchHorizontalSvg;
export const IcnTriangleWarning = IcnTriangleSvg;
